import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import App from './App';
import { getClerkPublishableKey } from './config/environments';
// Import Font Awesome CSS
import '@fortawesome/fontawesome-free/css/all.min.css';

// Import your Publishable Key
const PUBLISHABLE_KEY = getClerkPublishableKey();

if (!PUBLISHABLE_KEY || PUBLISHABLE_KEY === 'your-clerk-publishable-key-here') {
  throw new Error(
    'Missing or invalid Clerk Publishable Key. Please set VITE_CLERK_PUBLISHABLE_KEY in your .env file. ' +
    'Copy .env.example to .env and update with your actual Clerk keys.'
  );
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ClerkProvider publishableKey={PUBLISHABLE_KEY}>
      <App />
    </ClerkProvider>
  </React.StrictMode>
);